import "./application.css"
import "./javascripts/util/i18n"

import Alpine from "alpinejs"
import persist from "@alpinejs/persist"
import checkoutWizard from "./javascripts/checkout_wizard"
Alpine.plugin(persist)
// Components must be registered before start() or their x-data can't resolve.
Alpine.data("checkoutWizard", checkoutWizard)
window.Alpine = Alpine
Alpine.start()

import '@hotwired/turbo-rails'

import { Application } from '@hotwired/stimulus'

const application = Application.start()
application.debug = false
window.Stimulus = application

// Replace Turbo's native confirm() popup with the themed dialog. Customer pages
// carry `data-turbo-confirm` too (module update, cancel subscription, delete a
// company), and without this they fell back to the grey browser box.
import { setupConfirmDialog } from "../entrypoints/javascripts/confirm_dialog.js"
setupConfirmDialog()

import { watchSessionExpiry } from "./javascripts/session_expiry.js"
watchSessionExpiry()

const controllers = import.meta.glob('./controllers/**/*_controller.js', { eager: true })

for (const path in controllers) {
  const module = controllers[path]
  const name = path
    .replace('./controllers/', '')
    .replace('_controller.js', '')
    .replace(/\//g, '--')

  application.register(name, module.default)
}
